import React from 'react';

/**
 * Official Saudi Riyal (SAR) Currency Symbol Component
 * Based on the official Saudi Arabian Monetary Authority symbol
 */
const SARSymbol = ({ className = '', size = 16, color = 'currentColor', style = {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1124.14 1256.39"
      width={size}
      height={size * (1256.39 / 1124.14)}
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
      aria-label="Saudi Riyal"
    >
      <path
        fill={color}
        d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"
      />
      <path
        fill={color}
        d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"
      />
    </svg>
  );
};

/**
 * Renders currency with SAR symbol for Saudi Riyal
 * For other currencies, returns the symbol as text
 */
export const CurrencyDisplay = ({ 
  amount, 
  currency = 'SAR', 
  currencySymbol, 
  className = '',
  showSymbolOnly = false,
  size = 14
}) => {
  const formattedAmount = amount !== null && amount !== undefined 
    ? Number(amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    : '0.00';

  // Use official SAR symbol for Saudi Riyal
  if (currency === 'SAR') {
    if (showSymbolOnly) {
      return <SARSymbol size={size} className={className} />;
    }
    return (
      <span className={`inline-flex items-center gap-1 ${className}`}>
        <SARSymbol size={size} />
        <span>{formattedAmount}</span>
      </span>
    );
  }

  // For other currencies, use text symbol
  if (showSymbolOnly) {
    return <span className={className}>{currencySymbol || currency}</span>;
  }
  return (
    <span className={className}>
      {currencySymbol || currency} {formattedAmount}
    </span>
  );
};

export default SARSymbol;
